export const onLogEvent = async ({
  dispatch,
  action: { eventName, interactionData, immediate, options },
  options: {
    extra: { metrics },
  },
}) => {
  dispatch(metrics.logEvent(eventName, interactionData, immediate, options));
};

export const onIdentify = async ({
  action: { user, traits },
  options: {
    extra: { metrics },
  },
}) => metrics.identify(user, traits);
